import styled from 'styled-components';
import { ChipStyleMixin } from 'shared/styles';

export const AssociationsHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  span.a-heading {
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: -0.08px;
    color: #12344d;
    margin-top: 16px;
    margin-bottom: 12px;
  }
`;

export const AssociationsList = styled.div`
  border: 1px solid #eeeeee;
  border-radius: 4px;
  max-height: 30vh;
  overflow: auto;
`;

export const Association = styled.div`
  padding: 8px;
  :not(:last-child) {
    border-bottom: 1px solid #eeeeee;
  }
  div.a-name {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.08px;
    color: #12344d;
    margin-bottom: 8px;
  }
  div.a-channel-list {
    display: flex;
  }
  div.channel-chip {
    ${ChipStyleMixin}
    width: fit-content;
    font-weight: 400;
    line-height: 20px;
    color: #12344d;
    background: #ebeff3;
    border-radius: 4px;
    margin: 0 8px 8px 0;
  }
`;
